<template>
    <div class="totale-preventivo">
        <RightPanel title="Preventivo">
            <template>
                <h6>Per persona</h6>
                <div class="d-flex justify-content-between">
                    <h1 class="currency">{{totalePerPersona}} &euro;</h1>
                    <p>
                        <span>Totale</span><b>{{totale}} &euro;</b>
                    </p>
                </div>
            </template>
            <template v-slot:footer>
                <div>
                    <div class="w-100 text-center mt-2 mb-3">
                        <b>Riepilogo dati</b>
                    </div>
                    <div class="d-flex justify-content-between mb-3">
                        <div class="text-center" style="width: 33%">
                            <img class="icon-totale-preventivo mb-1" src="../../../assets/images/svg/blue/icone_altre-date.svg" height="24px"/>
                            <small class="text-uppercase d-block nowrap" style="height: 13px;">{{andataFormatted}}</small>
                            <small class="text-uppercase d-block nowrap" style="height: 13px;">{{ritornoFormatted}}</small>
                        </div>
                        <div class="text-center" style="width: 34%">
                            <img class="icon-totale-preventivo mb-1" src="../../../assets/images/svg/blue/icone_volo.svg" height="24px"/>
                            <small class="d-block font-weight-bold" style="height: 13px;">Partenza da</small>
                            <small class="d-block" style="height: 13px;">{{aereoporto}}</small>
                        </div>
                        <div class="text-center" style="width: 33%">
                            <img class="icon-totale-preventivo mb-1" src="../../../assets/images/svg/blue/icone_notti.svg" height="24px"/>
                            <div>
                                <b>{{nights}}</b><small class="ml-1">{{nights===1? 'notte' : 'notti'}}</small>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between mb-3">
                        <div class="text-center" style="width: 33%">
                            <img class="icon-totale-preventivo mb-1" src="../../../assets/images/svg/blue/icone_passeggeri.svg" height="24px"/>
                            <small class="d-block">{{camere}}</small>
                        </div>
                        <div class="text-center" style="width: 34%">
                            <img class="icon-totale-preventivo mb-1" src="../../../assets/images/svg/blue/icone_volo.svg" height="24px"/>
                            <div class="d-block">
                                <b>{{flights}}</b><small class="ml-1">{{flights===1? 'volo' : 'voli'}}</small>
                            </div>
                        </div>
                        <div class="text-center" style="width: 33%">
                            <img class="icon-totale-preventivo mb-1" src="../../../assets/images/svg/blue/icone_attivita.svg" height="24px"/>
                            <div class="d-block">
                                <b>{{services}}</b><small class="ml-1">attività</small>
                            </div>
                        </div>
                    </div>
                    <div class="text-center mb-3" v-if="hasArrivalServiceTransfer()">
                        <img class="icon-alert-night-transfer" src="../../../assets/images/svg/red/icone_alert.svg" height="18px"/>
                        <div class="d-block">
                            <b>1</b><small class="ml-1">notte transfer</small>
                        </div>
                    </div>
                </div>
                <modal-change-search ref="modalChangeSearch" @change="onClickModify"/>
            </template>
        </RightPanel>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import DefaultPanel from '../../templates/DefaultPanel'
import RightPanel from '../../templates/RightPanel'
import {formatMoney, longDateFormatter} from '../../../utils/formatter'
import {camereText} from '../../../utils/helper'
import ModalChangeSearch from '../pages/volo-hotel/modals/ModalChangeSearch'
import {PRODUCT_EXPERIENCE, PRODUCT_TOUR} from '../../../types/products'

export default {
  name: 'TotalePreventivo',
  components: {ModalChangeSearch, RightPanel, DefaultPanel},
  computed: {
    experience () {
      return this.getExperienceSelected()
    },
    tour () {
      return this.getTour()
    },
    search () {
      return this.getSearch()
    },
    aereoporto () {
      if (this.getTour() != null) {
        const from = this.getFlightFrom()
        return from.voli[0].partenza.aeroporto.city.objA
      }
      if (!this.search || !this.search.aereoporto) return ''
      return this.search.aereoporto.label.split(' ')[0]
    },
    camere () {
      return camereText(this.search.camere)
    },
    andataFormatted () {
      const andata = this.search.andata ? this.search.andata : this.search.partenza
      return longDateFormatter(andata)
    },
    ritornoFormatted () {
      if (this.search.product === PRODUCT_EXPERIENCE) {
        const ritorno = this.$moment(this.search.partenza).add(this.experience.days.length, 'days')
        return longDateFormatter(ritorno)
      }
      if (this.search.product === PRODUCT_TOUR) {
        const ritorno = this.$moment(this.search.partenza).add(this.tour.anagrafica.element.days - 1, 'days')
        return longDateFormatter(ritorno)
      }
      return longDateFormatter(this.search.ritorno)
    },
    totalePerPersona () {
      return formatMoney(this.summary.totalPricePerPerson)
    },
    totale () {
      return formatMoney(this.summary.totalPrice)
    },
    flights () {
      return this.summary.flights
    },
    nights () {
      return this.summary.nights
    },
    services () {
      return this.summary.services
    },
    summary () {
      return this.getSummary()
    }
  },
  methods: {
    ...mapGetters(['hasArrivalServiceTransfer', 'getSearch', 'getExperienceSelected', 'getSummary', 'getTour', 'getFlightFrom']),
    onClickModify: function () {
      this.$refs.modalChangeSearch.open()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/TotalePreventivo.vue